if (!customElements.get("yc-dot-scroller")) {
  class YCDotScroller extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.activateDot = this.activateDot.bind(this);
      this.renderDots = this.renderDots.bind(this);
      this.checkContentOverflow = this.checkContentOverflow.bind(this);

      this.scrollContainer = this.querySelector(
        ".yc-dot-scroller__scroll-container",
      );
      if (!this.scrollContainer) {
        console.warn(
          "YCDotScroller -  .yc-dot-scroller__scroll-container container not found",
        );
        return;
      }

      const dotsContainer = document.createElement("div");
      dotsContainer.className = "yc-dot-scroller__dots yc-carousel-indicators";

      // look for arrow buttons
      this.arrowButtons = this.querySelectorAll(".arrow-button");
      if (this.arrowButtons.length != 0) {
        this.arrowButtons.forEach((button, i) => {
          button.addEventListener("click", () => {
            const direction = i % 2 === 1 ? 1 : -1;

            const { clientWidth } = this.scrollContainer;
            const scrollAmount = direction * clientWidth * 1; // Scroll by 100% of container width
            this.scrollContainer.scrollBy({
              left: scrollAmount,
              behavior: "smooth",
            });
          });
        });
      }

      window.addEventListener("resize", () => {
        this.renderDots();
        this.handleScroll(); // Recalculate on resize
        this.checkContentOverflow();
      });

      this.appendChild(dotsContainer);

      this.dotsContainer = dotsContainer;

      this.renderDots();

      this.checkContentOverflow();
    }

    // check if we should hide the arrow buttons and dots if we only have one page of content
    checkContentOverflow() {
      const { scrollWidth, clientWidth } = this.scrollContainer;
      const totalDots = Math.ceil(scrollWidth / clientWidth);

      if (totalDots <= 1) {
        this.dotsContainer.style.display = "none";
        if (this.arrowButtons) {
          this.arrowButtons.forEach((button) => {
            button.style.display = "none";
          });
        }
      } else {
        this.dotsContainer.style.display = "flex";
        if (this.arrowButtons) {
          this.arrowButtons.forEach((button) => {
            button.style.display = "block";
          });
        }
      }
    }

    renderDots() {
      if (!this.dotsContainer) {
        console.warn("Dots container not found");
        return;
      }

      const scrollContainer = this.querySelector(
        ".yc-dot-scroller__scroll-container",
      );
      const { scrollWidth, clientWidth } = scrollContainer;
      const totalDots = Math.ceil(scrollWidth / clientWidth);

      this.dotsContainer.innerHTML = "";
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement("div");
        dot.className =
          "yc-dot-scroller__dot yc-carousel-indicators__indicator ";
        this.dotsContainer.appendChild(dot);

        dot.addEventListener("click", () => {
          const targetScrollLeft =
            (i / (totalDots - 1)) * (scrollWidth - clientWidth);
          scrollContainer.scrollTo({
            left: targetScrollLeft,
            behavior: "smooth",
          });
        });
      }

      //console.log("Dots rendered:", totalDots);

      if (totalDots <= 1) {
        this.dotsContainer.style.display = "none";
        if (this.arrowButtons) {
          this.arrowButtons.forEach((button) => {
            button.style.display = "none";
          });
        }
      } else {
        this.dotsContainer.style.display = "flex";
        if (this.arrowButtons) {
          this.arrowButtons.forEach((button) => {
            button.style.display = "block";
          });
        }
      }
    }

    activateDot(percentage) {
      const dots = this.dotsContainer.querySelectorAll(".yc-dot-scroller__dot");
      const activeIndex = Math.round((percentage / 100) * (dots.length - 1));

      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector(
        ".yc-dot-scroller__scroll-container",
      );
      if (this.scrollContainer) {
        this.scrollContainer.addEventListener("scroll", this.handleScroll);
        this.handleScroll(); // Initial call to set the state
      }
    }

    disconnectedCallback() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener("scroll", this.handleScroll);
      }
    }

    handleScroll() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const maxScrollLeft = scrollWidth - clientWidth;

      const percentage = (scrollLeft / maxScrollLeft) * 100;
      this.style.setProperty("--scroll-percentage", `${percentage}%`);

      this.activateDot(percentage);

      // Update classes based on scroll position

      if (Math.round(percentage) === 0) {
        this.classList.add("at-start");
        this.classList.remove("at-end");
        if (this.arrowButtons[0]) {
          this.arrowButtons[0].setAttribute("disabled", "true");
        }
      } else if (Math.round(percentage) === 100) {
        this.classList.add("at-end");
        this.classList.remove("at-start");

        if (this.arrowButtons[1]) {
          this.arrowButtons[1].setAttribute("disabled", "true");
        }
      } else {
        this.classList.remove("at-start", "at-end");
        if (this.arrowButtons[1]) {
          this.arrowButtons[1].removeAttribute("disabled");
        }
        if (this.arrowButtons[0]) {
          this.arrowButtons[0].removeAttribute("disabled");
        }
      }
    }
  }

  customElements.define("yc-dot-scroller", YCDotScroller);
}
